import React, { Suspense } from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import MainLayout from '../containers/MainLayout';
import LoadingIndicator from 'components/LoadingIndicator';
import { ErrorBoundary } from 'components/ErrorBoundary';
import ProductListingContent from './ProductListingLayout';

interface MainLayoutProps extends RouteProps {
  component: any;
  redirect?: string;
  isAuth?: boolean;
  requiredAuthorize?: boolean;
  listing?: boolean;
}

function MainLayoutRoute({
  component: Component,
  redirect = '/signin',
  isAuth: isAuthProp,
  listing = false,
  ...rest
}: MainLayoutProps) {
  const isAuth = isAuthProp ?? !listing;
  const loggedIn = !!localStorage.getItem('token');
  return (
    <Route
      {...rest}
      render={(matchProps) => {
        if (!isAuth || loggedIn) {
          // react-router 5 giữ nguyên instance khi điều hướng giữa 2 URL cùng <Route>
          // (vd /products/A -> /products/B). Các trang fetch theo URL lúc mount (saga
          // RESTART_ON_REMOUNT) sẽ hiển thị dữ liệu cũ. key theo pathname buộc remount ->
          // refetch. Trang list dạng query-string (/thuong-hieu = AllBrandPage) đổi ?name=
          // trên cùng pathname nên phải kèm search vào key.
          const remountKey =
            matchProps.location.pathname === '/thuong-hieu'
              ? matchProps.location.pathname + matchProps.location.search
              : matchProps.location.pathname;
          if (!listing) {
            // eslint-disable-next-line no-param-reassign
            matchProps.location.state = { redirectPath: null };
          }
          return (
            <MainLayout key={loggedIn ? 'user' : 'guest'}>
              {listing ? (
                <ProductListingContent component={Component} matchProps={matchProps} />
              ) : (
                <ErrorBoundary key={remountKey}>
                  <Suspense fallback={<LoadingIndicator />}>
                    <Component key={remountKey} {...matchProps} />
                  </Suspense>
                </ErrorBoundary>
              )}
            </MainLayout>
          );
        }
        return (
          <Redirect
            to={{
              pathname: redirect,
              state: { referrer: matchProps.location, redirectPath: redirect },
            }}
          />
        );
      }}
    />
  );
}

MainLayoutRoute.displayName = 'MainLayoutRoute';

export default MainLayoutRoute;
